import { useState } from 'react'

/**
 * Mapbox requires a session token for geocoding API requests.
 * This token helps Mapbox track and optimize API usage across sessions.
 * The token is generated on our side and stored in localStorage with an expiration time.
 */
const SESSION_KEY = 'mapbox_session_token'
const EXPIRATION_KEY = 'mapbox_session_token_expiration'
const EXPIRATION_MS = 60 * 60 * 1000

// Generate UUID-like token
function generateToken (): string {
  return Math.random().toString(36).substring(2) + Date.now().toString(36)
}

function getOrCreateToken (): string {
  const now = Date.now()
  const existing = localStorage.getItem(SESSION_KEY)
  const expiration = parseInt(localStorage.getItem(EXPIRATION_KEY) || '0', 10)

  if (existing && expiration && now < expiration) {
    return existing
  }

  const newToken = generateToken()
  localStorage.setItem(SESSION_KEY, newToken)
  localStorage.setItem(EXPIRATION_KEY, (now + EXPIRATION_MS).toString())
  return newToken
}

export function useMapboxSessionToken (): string {
  const [token] = useState(() => getOrCreateToken())
  return token
}
